import React, { useEffect, useState } from "react";
import Sidebar from "../../../layouts/sidebar";
import Headers from "../../../layouts/header";
import Select from "react-select";
import Datetime from "react-datetime";
import moment from "moment";
import "react-datetime/css/react-datetime.css";
import { Nav, Tab, Row, Col } from "react-bootstrap";
import { styled } from "@mui/material/styles";
import BootstrapTable from "react-bootstrap-table-next";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import { IoIosSend } from "react-icons/io";
import { FaEyeSlash, FaEye, FaTrash, FaPen } from "react-icons/fa";


import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router";
import useAxiosFile from "../../../actions/useaxios";
import {
  EncryptData,
  isEmpty,
  LoadToast,
  updateToast,
} from "../../../actions/common";
import { Link } from "react-router-dom";
import Exportcsv from "../Managementpages/Exportcsv";
import { data } from "jquery";
import { toast } from 'react-toastify';

function CouponsList() {
  const { toggle } = useSelector((state) => state.admin_panel.User);
  const [selectedOption, setSelectedOption] = useState(null);
  const [rightside, setRightSide] = useState(null);
  const [exportdata, setExportdata] = useState([]);
  const axiosFile = useAxiosFile();

  const [Drivers, SetDrivers] = useState([]);
  const navigate = useNavigate();
  // const location = useLocation();
  // const state = location.state;
  // console.log("statryeeee",state,location);
  useEffect(() => {
    GetDrivers();
  }, []);

  const GetDrivers = async () => {
    let Resp = await axiosFile.CouponList({ from: "admin" });
    // let Resp = await axiosFile.CouponList();
    console.log("sd", Resp);
    SetDrivers(Resp.data);
  }


  const Delete = async (_id) => {
    let Resp = await axiosFile.getCouponList({ _id: _id, action: "delete" });
    GetDrivers()
  }

  async function Hideshow(_id, cell) {

    let Resp = await axiosFile.getCouponList({ _id: _id, action: "hideshow", "visible": cell == "show" ? "hide" : "show" });
    toast.success("Updated Successfully")
    GetDrivers()
  }

  const pagination = paginationFactory({
    page: 1,
    sizePerPage: 5,
    lastPageText: ">>",
    firstPageText: "<<",
    nextPageText: ">",
    prePageText: "<",
    showTotal: true,
    alwaysShowAllBtns: true,
    onPageChange: function (page, sizePerPage) { },
    onSizePerPageChange: function (page, sizePerPage) { },
  });

  const stylesgraybg = {
    option: (styles, { isFocused, isSelected, isHovered }) => ({
      ...styles,
      color: "#6C6A81",
      background: isFocused
        ? "#F5F6F7"
        : isSelected
          ? "#F5F6F7"
          : isHovered
            ? "red"
            : "#F5F6F7",

      zIndex: 1,
      cursor: "pointer",
      fontSize: "13px",
    }),

    option: (styles, { isFocused, isSelected, isHovered }) => {
      // const color = chroma(data.color);

      return {
        ...styles,
        backgroundColor: isHovered
          ? "#a71d24"
          : isSelected
            ? "#a71d24"
            : isFocused
              ? "#a71d24"
              : "",
        cursor: "pointer",
        color: isHovered
          ? "#fff"
          : isSelected
            ? "#fff"
            : isFocused
              ? "#fff"
              : "",
        fontSize: "13px",
      };
    },
    valueContainer: (provided, state) => ({
      ...provided,
      height: "40px",
      padding: "0 20px",
      backgroundColor: "#fff ",
      border: "1px solid rgba(34, 34, 34, 0.32)",
      borderRadius: 10,
      fontSize: "13px",
    }),
    control: (provided, state) => ({
      ...provided,
      height: "40px",
      borderRadius: 10,
      backgroundColor: "#fff",
      border: "none",
      outline: "none",
      boxShadow: "none",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "40px",
      position: "absolute",
      right: 0,
      top: 0,
      color: "#6C6A81",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: "#6C6A81",
    }),
    menuList: (base) => ({
      ...base,
      // kill the white space on first and last option
      padding: 0,
    }),
  };

  const subdetailbutton = async (e, data) => {
    let id = LoadToast();

    let cell = {
      id: data._id,
      check: e.target.checked,
    };
    console.log("datsssss", data, e.target.checked);
    var data = await axiosFile.couponsend(cell);
    console.log("eFCSEfddfbdvf", data);
    updateToast(id, data.msg, data.success);
    if (data.success == "success") {
      console.log("statusdata", data.status);
      GetDrivers();
    }
  };

  const columns = [
    // { dataField: "hash", text: "#", formatter: (cell, row,rowindex) => (
    //  <div>{rowindex+1}</div>
    // ) },
    { dataField: "CouponCode", text: "Coupon Code", sort: true },
    { dataField: "CouponTitle", text: "Title", sort: true },
    { dataField: "Expiry", text: "Expiry", sort: true },
    {
      dataField: "_id", text: "Shop name", formatter: (cell, row) => (
        (row.CouponType == "1storder") ?
          <>Default Coupon</> :
          ((row?.ApprovedShop)?.filter(it => !isEmpty(it))?.length > 0 ?
            <div className="d-flex justify-content-center">
              <button
                className="pads_bord_btn d-flex align-items-center justify-content-center gap-1"
                onClick={() => {
                  console.log("cellcellcellcellcellcellcell", cell, row)
                  navigate(`/coupons/?Id=${EncryptData(JSON.stringify({ Id: cell, action: 'send' }))}`,
                  )
                }}
              >
                {console.log("cell.CouponType", JSON.stringify(cell, row))}
                <IoIosSend fontSize={16} />

                Send
              </button>
            </div>

            : <>Waiting for approval</>)
      ),
    },
    {
      dataField: "visible", text: "Hide/Show", formatter: (cell, row) => (
        <div className="d-flex justify-content-center">
          <button
            className="pads_bord_btn "
            // `/coupons/?Id=${EncryptData(val._id)}`
            onClick={() => Hideshow(row?._id, cell)}
          >
            {cell == "show" ? <div className="d-flex align-items-center justify-content-center gap-2"><FaEyeSlash fontSize={14} /> Hide</div> : <div className="d-flex align-items-center justify-content-center gap-2"><FaEye fontSize={14} />Show</div>}
          </button>
        </div>

      ),
    },
    {
      dataField: "_id", text: "Delete", formatter: (cell, row) => (
        <div className="d-flex justify-content-center">
          <button
            className="pads_bord_btn d-flex align-items-center justify-content-center gap-2"
            // `/coupons/?Id=${EncryptData(val._id)}`
            onClick={() => Delete(cell)}
          >
            <FaTrash fontSize={12} />
            Delete
          </button>
        </div>

      ),
    },

    {
      dataField: "_id",
      text: "Edit",
      formatter: (cell, row) => (
        <div className="d-flex justify-content-center">
          <button
            className="pads_bord_btn d-flex align-items-center justify-content-center gap-2"
            onClick={() => navigate(`/coupons/?Id=${EncryptData(JSON.stringify({ Id: cell, action: 'edit' }))}`,
              // state:{action:'edit',Id:EncryptData(row._id)}
            )}
          >
            <FaPen fontSize={12} />
            Edit
          </button>
        </div>

      ),
    },


  ];

  return (
    <>
      <div>
        <div className="innerpages">
          <div className="orders_pages">
            <Headers />
            <div className="container custom_container px-lg-0">
              <div className="row mx-auto">
                <div className="innerpages_wid px-0">
                  <Sidebar />
                  <div
                    className={
                      toggle
                        ? "content-sec-inner right_widthset content_without_sidebar"
                        : "content-sec-inner  content_with_sidebar"
                    }
                  >
                    <section id="content-wrapper">
                      <div class="row">
                        <div className="top_title_sec">
                          <div>
                            <p className="page_title">Coupons</p>
                          </div>
                          <div className="rightside">
                            <button
                              type="button"
                              className="blue_btn add_deliveryprsn dp_btn_hover"
                              onClick={() => navigate("/coupons")}
                            >
                              Add Coupons
                            </button>
                            {/* <button type="button" className='btn primary-style export_csv'>
      Export to CSV
     </button> */}
                            {/* <button
                              type="button"
                              className="btn primary-style export_csv"
                            >
                              <Exportcsv
                                csvData={exportdata}
                                fileName={"users"}
                              />
                            </button> */}
                            <Exportcsv
                              className="cmn_exportcsv"
                              csvData={exportdata}
                              fileName={"users"}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row mt-4 mx-auto">
                        <div className="sec_border">
                          <div className="row">

                            <div className="col-xxl-8 col-xl-8 col-lg-9 col-md-9 col-sm-12 col-12">

                            </div>
                            <div className="ffd_table mar_bot vendor_table_align">
                              <BootstrapTable
                                bootstrap4
                                keyField="id"
                                columns={columns}
                                data={Drivers}
                                pagination={pagination}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CouponsList;
